import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendQueryVerifySsoEmailArgs,
  BackendVerifySsoEmailResult,
} from 'src/types/backend';

const QUERY = gql`
  query VerifySSOEmail($email: String!) {
    verifySsoEmail(email: $email) {
      valid
    }
  }
`;

type Variables = BackendQueryVerifySsoEmailArgs;
type Result = BackendVerifySsoEmailResult;

export const verifySSOEmail = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
